module.exports = __webpack_public_path__ + "static/media/app-nickname.0976748f.png";